import { FC, useEffect } from "react";
import NavbarContent from "../navbar-content";
import { useResponsive } from "../../../hooks";
import { useNavStore } from "../../../stores";

const NavbarContainer: FC = () => {
  const isMobile = useResponsive();
  const { blurWidth, containerWidth, setContainerWidth, closeAndHideNav } =
    useNavStore();

  useEffect(() => {
    setContainerWidth(!isMobile ? 96 : 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobile]);

  return (
    <div
      style={{
        height: "100vh",
        position: "absolute",
        top: 0,
        right: 0,
        width: containerWidth,
        zIndex: 10,
      }}
      className="transition"
      onClick={isMobile ? closeAndHideNav : () => {}}
    >
      <div
        style={{
          height: "100vh",
          position: "absolute",
          top: 0,
          right: 0,
          width: blurWidth,
          zIndex: 10,
          backdropFilter: "blur(20px)",
        }}
        className="transition"
      ></div>
      <NavbarContent />
    </div>
  );
};

export default NavbarContainer;
